import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FactoringOperationDTO, InvoiceBuyOrderMinuteDTO } from '../../minutes/interface/minute-detail';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';

@Component({
  selector: 'app-minute-operations-list',
  templateUrl: './minute-operations-list.component.html',
  styleUrls: ['./minute-operations-list.component.scss']
})
export class MinuteOperationsListComponent implements OnInit, OnChanges {
  public order: any;
  public menu!: CdkContextMenuTrigger;
  @Input() operations: Array<FactoringOperationDTO>;
  @Input() forMinute: boolean = false;
  @Output() invoiceOperationToUpdate = new EventEmitter<FactoringOperationDTO>;
  @ViewChild(MatSort, { static: true})
  sort: MatSort = Object.create(null);
  public ordenes: InvoiceBuyOrderMinuteDTO;

  public dataSource!: MatTableDataSource<FactoringOperationDTO>;
  public dataSourceOrder!: MatTableDataSource<InvoiceBuyOrderMinuteDTO>;
  public displayedCols = [
    'folio',
    'debtorRut',
    'debtorName',
    'invoiceTotalAmount',
    'financedAmount',
    'plazo',
    'rate',
    'allInRate',
    'comment'
  ];
  public displayedColsOrder = [
    'amount',
    'code',
    'fechaEmision',
    'plazo',
    'sigfe'
  ];
  
  constructor() {
    this.dataSource = new MatTableDataSource<FactoringOperationDTO>([]);
    this.dataSourceOrder = new MatTableDataSource<InvoiceBuyOrderMinuteDTO>([]);
  }

  ngOnInit(): void {
    if(!this.forMinute){
      this.displayedCols.push('operationState');
    }
    this.dataSource = new MatTableDataSource<FactoringOperationDTO>([]);
    this.dataSource.sort = this.sort;
    this.dataSourceOrder = new MatTableDataSource<InvoiceBuyOrderMinuteDTO>([]);
    this.dataSourceOrder.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['operations'] && changes['operations'].currentValue) {
      this.dataSource.data = changes['operations'].currentValue;
      this.dataSource.sort = this.sort;
      if(this.dataSource.data['buyOrder'] != null) {
        for(let operacion of this.dataSource.data)
          {
            this.dataSourceOrder.data.push(operacion.buyOrder);
          }
          this.dataSourceOrder.sort = this.sort;
      }
    }
  }

  /**
   * Metodo para solicitar recalculo de montos
   * @param operation Operacion a recalcular
   */
  selectOperationToUpdate(operation: FactoringOperationDTO) {
    this.invoiceOperationToUpdate.emit(operation);
  }
}
